(function () {
  'use strict';
 
  const LIMIT = 2;
  const moneyFormat = window.theme?.moneyFormat || window.Shopify?.money_format || '${{amount}}';
 
  function formatMoney(cents) {
    const value = cents / 100;
 
    function withDelimiters(number, precision, thousands, decimal) {
      const fixed = (number || 0).toFixed(precision);
      const parts = fixed.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      const dec = parts[1] ? decimal + parts[1] : '';
      return whole + dec;
    }
 
    const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return moneyFormat;
 
    let formatted;
    switch (match[1]) {
      case 'amount':
        formatted = withDelimiters(value, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        formatted = withDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = withDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = withDelimiters(value, 2, "'", '.');
        break;
      default:
        formatted = withDelimiters(value, 2, ',', '.');
    }
 
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
  }
 
  // Get size option index (handles "Size", "size", "SIZE")
  function getSizeIndex(product) {
    return product.options.findIndex(o => {
      const name = typeof o === 'string' ? o : o.name;
      return name.toLowerCase() === 'size';
    });
  }
 
  // Return Map of { sizeLabel -> variant } for available variants only
  function getAvailableSizes(product) {
    const idx = getSizeIndex(product);
    if (idx === -1) return null;
    const map = new Map();
    product.variants.forEach(v => {
      if (v.available) {
        const label = v[`option${idx + 1}`];
        if (!map.has(label)) map.set(label, v);
      }
    });
    return map;
  }
 
function renderCard(product) {
    const sizes = getAvailableSizes(product);
    const price = formatMoney(product.price);
    const imgSrc = typeof product.featured_image === 'string'
      ? product.featured_image
      : (product.featured_image?.src || '');
    const img = imgSrc ? imgSrc.replace(/(\.\w+(\?.*)?$)/, '_160x200_crop_center$1') : '';
 
    // Single-variant product (no size option)
    const singleVariant = !sizes && product.variants.length === 1 && product.variants[0].available
      ? product.variants[0]
      : null;
 
    const sizeBtns = sizes && sizes.size > 0
      ? `<div class="cart-rec__sizes">
          ${Array.from(sizes.entries()).map(([label, v]) =>
            `<button class="cart-rec__size" type="button" data-variant-id="${v.id}">${label}</button>`
          ).join('')}
         </div>`
      : '';
 
    return `
      <div class="cart-rec__item" data-rec-item>
        ${img ? `<a href="/products/${product.handle}" class="cart-rec__img-wrap">
          <img src="${img}" alt="${product.title}" width="80" loading="lazy">
        </a>` : ''}
        <div class="cart-rec__details">
          <a href="/products/${product.handle}" class="cart-rec__name">${product.title}</a>
          <span class="cart-rec__price">${price}</span>
          ${sizeBtns}
          <button
            class="cart-rec__add"
            type="button"
            ${singleVariant ? `data-variant-id="${singleVariant.id}"` : ''}
            ${sizes && sizes.size > 0 ? 'data-needs-size="true" disabled' : ''}
            ${!sizes && !singleVariant ? 'disabled' : ''}>
            ${'Add to cart'}
          </button>
        </div>
      </div>`;
  }
 
  function bindEvents(wrap) {
    // Size selection
    wrap.querySelectorAll('.cart-rec__size').forEach(btn => {
      btn.addEventListener('click', function () {
        const item = this.closest('[data-rec-item]');
        item.querySelectorAll('.cart-rec__size').forEach(b => b.classList.remove('is-active'));
        this.classList.add('is-active');
 
        const addBtn = item.querySelector('.cart-rec__add');
        addBtn.dataset.variantId = this.dataset.variantId;
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      });
    });
 
    // Add to cart
    wrap.querySelectorAll('.cart-rec__add').forEach(btn => {
      btn.addEventListener('click', async function () {
        if (this.disabled || !this.dataset.variantId) return;
 
        this.disabled = true;
 
          try {
            const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(this.dataset.variantId), quantity: 1 })
          });
 
          if (!res.ok) throw new Error();
 
          this.textContent = 'Added!';
 
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
 
          setTimeout(() => {
            const wrap = document.querySelector('[data-cart-recommendations]');
            if (wrap) { wrap.innerHTML = ''; load(wrap); }
          }, 1000);
 
        } catch {
          this.textContent = 'Try again';
          this.disabled = false;
        }
      });
    });
  }
 
  async function load(container) {
    try {
      const [cartRes] = await Promise.all([fetch('/cart.js')]);
      const cart = await cartRes.json();
 
      if (!cart.items?.length) { container.innerHTML = ''; return; }
 
      const productId = cart.items[0].product_id;
      const cartProductIds = new Set(cart.items.map(i => i.product_id));
 
      const recRes = await fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`);
      const { products } = await recRes.json();
 
      // Filter already-in-cart products, take first LIMIT
      const filtered = products.filter(p => !cartProductIds.has(p.id)).slice(0, LIMIT);
 
      if (!filtered.length) { container.innerHTML = ''; return; }
 
      container.innerHTML = `
        <div class="cart-rec">
          <p class="cart-rec__heading">You may also like</p>
          ${filtered.map(renderCard).join('')}
        </div>`;
 
      bindEvents(container);
 
    } catch (e) {
      container.innerHTML = '';
    }
  }
 
  // Watch for the container entering the DOM (fires on every template re-render)
  function init() {
    const observer = new MutationObserver(() => {
      const container = document.querySelector('[data-cart-recommendations]');
      if (container && !container.dataset.recLoading && container.innerHTML.trim() === '') {
        container.dataset.recLoading = 'true';
        load(container).finally(() => delete container.dataset.recLoading);
      }
    });
 
    observer.observe(document.body, { childList: true, subtree: true });
 
    const existing = document.querySelector('[data-cart-recommendations]');
    if (existing) load(existing);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
})();